import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { getMyRateURL } from '@/utils/helpers';
export type PaymentMethod = {
  url: string;
};

export const createPaymentMethod = (): Promise<PaymentMethod> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'customer-portal-session';

  const postData = { returnUrl: getMyRateURL() };

  return axios.post(endPoint, postData).then((response: any) => {
    if (typeof response === 'string') {
      throw Error(`Critical error fetching data in ${endPoint}`);
    }
    return response.url;
  });
};
